export const hueRangeDefault = [185, 340];
export const satRangeDefault = [0.6, 0.9];
export const litRangeDefault = [0.2, 0.7];
export const surveyHueRange = [260, 290];
export const respondentsHueRange = [260, 360];
export const heatmapLegendColors = ['#bbacc7', '#583079'];



// WEBPACK FOOTER //
// ./src/mixins/colorConstants_live.js